import React from 'react';
import { connect } from 'react-redux';
import { getIsSummitCard, supportUpgradeCta } from '../../redux';
import BauReinforcementBanner from './components/BauReinforcementBanner';
import SummitReinforcementBanner from './components/SummitReinforcementBanner';
import {
  shouldShowDynamicAppPDP,
  getDynamicAppReinforcementBannerContent
} from 'page_modules/business-pdp/redux/index.js';

const ReinforcementBanner = React.memo(function ReinforcementBanner({
  isSummitCard,
  bannerData,
  hasUpgradeCta,
  showDynamicApp
}) {
  return isSummitCard && !showDynamicApp ? (
    <SummitReinforcementBanner
      hasUpgradeCta={hasUpgradeCta}
      bannerData={bannerData}
    />
  ) : (
    <BauReinforcementBanner
      hasUpgradeCta={hasUpgradeCta}
      bannerData={bannerData}
      dynAppStyling={showDynamicApp}
    />
  );
});

const mapStateToProps = state => ({
  isSummitCard: getIsSummitCard(state),
  bannerData: getDynamicAppReinforcementBannerContent(state),
  hasUpgradeCta: supportUpgradeCta(state),
  showDynamicApp: shouldShowDynamicAppPDP(state)
});

export default connect(mapStateToProps)(ReinforcementBanner);
